import styled from 'styled-components';

import { px } from '../../contrib/ui';

export const SendNotificationFormStyled = styled.div`
  .radio-group-container {
    .modal-action {
      button {
        max-width: 100%;

        .icon {
          display: flex;
          margin-right: ${px(8)};
          position: relative;
          top: -0.08em;

          img {
            height: ${px(18)};
          }
        }
      }
    }

    .grid-item {
      .send-form-label {
        @mixin centered-text;
        align-items: center;
        color: var(--grey9b);
        display: flex;
        font-family: 'DINNextLTPro-Regular';
        font-size: ${px(16)};
        height: ${px(40)};
        justify-content: center;
        text-transform: uppercase;
      }

      .event-selector {
        padding: ${px(10)};
        margin: ${px(-10)};
        margin-left: ${px(16)};
      }

      .select-button {
        margin-top: ${px(15)};
        font-size: var(--midButtonText);
        height: var(--midButtonHeight);

        & > span:first-child {
          height: var(--midButtonHeight);
          .title {
            .angle,
            .angle2 {
              height: calc((var(--midButtonHeight) / 2) * 1.1547);
            }
          }
        }
      }

      .autocomplete__menu {
        position: relative;
      }

      .autocomplete {
        .autocomplete__control {
          padding-left: 35%;

          .autocomplete__placeholder,
          .autocomplete__single-value {
            margin-left: 15px;
          }
        }
      }
    }
  }
`;
